import * as Yup from "yup";
import { TFunction } from "react-i18next";

export const requiredString = (t: TFunction) =>
  Yup.string().nullable().required(t("generic:validation-required"));
